import { render, staticRenderFns } from "./SameOrderPlushies.vue?vue&type=template&id=8d405aec&scoped=true&"
import script from "./SameOrderPlushies.vue?vue&type=script&lang=ts&"
export * from "./SameOrderPlushies.vue?vue&type=script&lang=ts&"
import style0 from "./SameOrderPlushies.vue?vue&type=style&index=0&id=8d405aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d405aec",
  null
  
)

export default component.exports